import { DataSetConfig } from 'libs/end-to-end/src/types/databases/data-sets/data-set';
import { MergeCategoryEnum } from 'libs/end-to-end/src/merge';
import { ResumeParsingCacheBusterDefaultVersion } from 'libs/end-to-end/src/types/databases/integrations/resume-parsing-cache-buster';

export const createDefaultConfigForMergeIntegration = ({
  category,
}: {
  category: MergeCategoryEnum;
}): DataSetConfig => {
  return {
    dataSetType: 'Integration',
    integration: {
      integrationType: 'Merge',
      accountToken: '',
      linkToken: '',
      magicLinkUrl: '',
      category,
      isIncrementalSyncEnabled: false,
      isConvertToParquetEnabled: false,
      isResumeParsingFilteringDisabled: false,
      resumeParsingCacheBusterVersion: ResumeParsingCacheBusterDefaultVersion,
      isResumeExtraFeaturesEnabled: false,
      snowflakeIntegrationEnabled: false,
      openAiModel: 'gpt-4o-mini',
    },
  };
};
